import styled from "styled-components";
import { colors } from "styles/theme";

export const Wrapper = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;

  > div {
    flex: 1;
  }
`;

export const FormActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
  background: ${colors.neutral_light};
  border-radius: 8px;
`; 

export const FormSection = styled.div`
  padding: 1.5rem 0;
`;

export const Container = styled.div`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

export const QuestionsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const QuestionActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`;